import Rete from 'rete'
import Swal from 'sweetalert2'
import camelCase from 'lodash.camelcase'
import startCase from 'lodash.startcase'

import { App } from '../App'
import { lang } from '../assets/lang'
import CONST_SOCKET from '../const/socket'
import CONST_COMPONENT from '../const/component'
import { CreateDefaultComponent } from './default-component'

export const handleOldDataOfDelay = (oldData) => {
  const delayReplyElement = $('#delay-delay-in-reply')
  const delayTextElement = $('#delay-delay-text')
  const typingOnDisplayElement = $('#delay-typing-on-display')

  const delayReplyFor = parseInt(oldData.delayReplyFor, 10) || 0
  const IsTypingOnDisplayChecked = oldData.IsTypingOnDisplayChecked || false

  delayReplyElement.val(delayReplyFor)
  delayTextElement.text(delayReplyFor + ' ' + lang.delay_html_info_sec)
  typingOnDisplayElement.prop('checked', IsTypingOnDisplayChecked)

  delayReplyElement.on('change', function(e) {
    const currentValue = e.target.value
    delayTextElement.text(currentValue + ' ' + lang.delay_html_info_sec)
  })
}

export const handleDataOfDelay = () => {
  const delayReplyFor = $('#delay-delay-in-reply').val()
  const IsTypingOnDisplayChecked = $('#delay-typing-on-display').prop('checked')

  if (parseInt(delayReplyFor, 10) < 0 || parseInt(delayReplyFor, 10) > 60) {
    return Swal.showValidationMessage(lang.delay_html_msg_delay_range)
  }

  return {
    delayReplyFor,
    IsTypingOnDisplayChecked,
  }
}

export const checksNodesAreConnected = (className) => {
  let status = false

  App.editor.nodes.forEach(node => {
    const allInputs = Array.from(node.inputs).some(([key, input]) => input.connections.length >= 1) // eslint-disable-line
    const allOutputs = Array.from(node.outputs).some(([key, output]) => output.connections.length >= 1) // eslint-disable-line

    if (false === allInputs && false === allOutputs) {
      status = true
      // return false
      addClassToNodeElement(className, node)
    }
  })

  return status
}

export const addClassIfNodesHaveNoValue = (className) => {
  let status = false
  const nodes = App.editor.nodes

  if (Array.isArray(nodes)) {
    for (const node of nodes) {
      const ignorableNodes = App.config.ignoreNodesWhileCheckingData
      if (ignorableNodes.length > 0) {
        if (ignorableNodes.indexOf(node.name) > -1) {
          continue;
        }
      }

      if (! hasNodeValue(node)) {
        if (false === status) {
          status = true
        }
  
        addClassToNodeElement(className, node)
      }
    }
  }
  
  return status
}

export const addClassIfOutputHasNoConnection = (componentName, socketName, className = '') => {
  let status = false
  App.editor.nodes.forEach(node => {
    if (componentName === node.name) {
      const connections = getNodeOutputConnectionsBySocketName(socketName, node)
      if (! connections.length) {
        if (CONST_COMPONENT.USER_INPUT_FLOW_SINGLE === node.name) {
          const connections2 = getNodeOutputConnectionsBySocketName(CONST_SOCKET.USER_INPUT_FLOW_SINGLE_OUTPUT_FINAL_REPLY, node)
          if (! connections2.length) {
            if (false === status) {
              status = true
            }
      
            if (className) {
              addClassToNodeElement(className, node)
            }
          }
        } else {          
          if (false === status) {
            status = true
          }
    
          if (className) {
            addClassToNodeElement(className, node)
          }
        }
      } else {
        if (className) {
          removeClassFromNodeElement(className, node)
        }
      }
    }
  })
  
  return status
}

const hasNodeValue = (node) => {
  if (0 === Object.keys(node.data).length) {
    return false
  }
  
  return true
}

export const warnIfSequenceSingleHasNonPromotionalValue = (className) => {
  let status = false

  App.editor.nodes.forEach(node => {
    if (CONST_COMPONENT.SEQUENCE === node.name) {
      const connections = getNodeOutputConnectionsBySocketName(CONST_SOCKET.SEQUENCE_OUTPUT, node)
      if (connections.length) {
        for (const connection of connections) {
          const inputNode = connection.input.node
          if (inputNode.data.isNonPromotionalChecked) {
            if (! node.data.closingTime || 
              ! node.data.messageTag || 
              ! node.data.startingTime || 
              ! node.data.timezone
            ) {
              if (false === status) {
                status = true
              }

              addClassToNodeElement(className, node)
            }
          }
        }
      }
    }
  })
  
  return status
}

export const hasNodeOutputEmptyConnection = (componentName, socketName) => {
  return App.editor.nodes.some(node => {
    if (componentName === node.name) {
      const connections = getNodeOutputConnectionsBySocketName(socketName, node)
      console.log(connections)
      return connections.length === 0
    }
  })
}

export const addClassToNodeElement = (className, node) => {
  if (node.vueContext && node.vueContext.$el) {
    if (! node.vueContext.$el.classList.contains(className)) {
      node.vueContext.$el.classList.add(className)
    }
  }
}

const removeClassFromNodeElement = (className, node) => {
  if (node.vueContext && node.vueContext.$el) {
    if (node.vueContext.$el.classList.contains(className)) {
      node.vueContext.$el.classList.remove(className)
    }
  }
}

export const createNewPostbackNode = async () => {
  const newPostbackComponent = App.components.get(CONST_COMPONENT.POSTBACK_NEW)
  const newPostbackInstance = new newPostbackComponent(App.config)
  const newPostbackNode = await newPostbackInstance.createNode()

  return newPostbackNode
}

export const createNewSequenceNode = async () => {
  const newSequenceComponent = App.components.get(CONST_COMPONENT.SEQUENCE)
  const newSequenceInstance = new newSequenceComponent(App.config)
  const newSequenceNode = await newSequenceInstance.createNode()

  return newSequenceNode
}

export const createSequenceSingleNode = async () => {
  const sequenceSingleComponent = App.components.get(CONST_COMPONENT.SEQUENCE_SINGLE)
  const squenceSingleInstance = new sequenceSingleComponent(App.config)
  const squenceSingleNode = await squenceSingleInstance.createNode()

  return squenceSingleNode
}

export const createUserInputFlowSingleNode = async () => {
  const userInputFlowSingleComponent = App.components.get(CONST_COMPONENT.USER_INPUT_FLOW_SINGLE)
  const userInputFlowSingleInstance = new userInputFlowSingleComponent(App.config)
  const userInputFlowSingleNode = await userInputFlowSingleInstance.createNode()

  return userInputFlowSingleNode
}

export const createActionButtonNode = async () => {
  const actionButtonComponent = App.components.get(CONST_COMPONENT.ACTION_BUTTON)
  const actionButtonInstance = new actionButtonComponent(App.config)
  const actionButtonNode = await actionButtonInstance.createNode()

  return actionButtonNode
}

export const createTriggerNode = async () => {
  const triggerComponent = App.components.get(CONST_COMPONENT.TRIGGER)
  const triggerInstance = new triggerComponent(App.config)
  const triggerNode = await triggerInstance.createNode()

  return triggerNode
}

export const createNodeByComponentName = async (componentName) => {
  const component = App.components.get(componentName)

  if (! component) {
    throw new Error('Could not find component by the name: ' + component)
  }

  const instance = new component(App.config)
  const node = await instance.createNode()

  return node
}

export const addNewSequenceToEditor = async (position) => {
  const newSequenceNode = await createNewSequenceNode()
  newSequenceNode.position = position

  App.editor.addNode(newSequenceNode)

  return newSequenceNode
}

export const addNewSequenceSingleToEditor = async (position) => {
  const sequenceSingleNode = await createSequenceSingleNode()
  sequenceSingleNode.position = position

  App.editor.addNode(sequenceSingleNode)

  return sequenceSingleNode
}

export const addNewPostbackNodeToEditor = async (position) => {
  const childNewPostbackNode = await createNewPostbackNode()
  childNewPostbackNode.position = position

  App.editor.addNode(childNewPostbackNode)

  return childNewPostbackNode
}

export const addOtnSingleNodeToEditor = async (position) => {
  const childOtnSingleNode = await createOtnSingleNode()
  childOtnSingleNode.position = position

  App.editor.addNode(childOtnSingleNode)

  return childOtnSingleNode
}

export const createOtnSingleNode = async () => {
  const otnSingleComponent = App.components.get(CONST_COMPONENT.OTN_SINGLE)
  const otnSingleInstance = new otnSingleComponent(App.config)
  const otnSingleNode = await otnSingleInstance.createNode()

  return otnSingleNode
}

export const createComponentListNode = async () => {
  const componentListNodeComponent = App.components.get(CONST_COMPONENT.COMPONENT_LIST)
  const componentListNodeInstance = new componentListNodeComponent(App.config)
  const componentListNodeNode = await componentListNodeInstance.createNode()

  return componentListNodeNode
}

export const createButtonNode = async () => {
  const buttonComponent = App.components.get(CONST_COMPONENT.BUTTON)
  const buttonInstance = new buttonComponent(App.config)
  const buttonNode = await buttonInstance.createNode()

  return buttonNode
}

export const removeNodes = (nodesList) => {
  if (Array.isArray(nodesList)) {
    for (const node of nodesList) {
      if (node instanceof Rete.Node) {
        App.editor.removeNode(node)
      }
    }
  }
}

export const createNodeOnClickComponentList = async (node, event) => {
  /*eslint no-case-declarations: "error"*/
  /*eslint-env es6*/
  const inputSocketName = event.target.dataset.inputSocketName
  const componentName = event.target.dataset.componentName
  const output = node.output.node.outputs.get(node.output.key)
  
  switch(componentName) {
    case CONST_COMPONENT.CAROUSEL: {
      const carouselNode = await createCarouselAndChildrenNodes(event)
      const carouselNodeInput = carouselNode.inputs.get(inputSocketName)
      App.editor.connect(output, carouselNodeInput)
      break
    }
    case CONST_COMPONENT.GENERIC_TEMPLATE: {
      const genericTemplateNode = await createGenericTemplateAndChildrenNodes(event)
      const genericTemplateNodeInput = genericTemplateNode.inputs.get(inputSocketName)
      App.editor.connect(output, genericTemplateNodeInput)
      break
    }
    case CONST_COMPONENT.SEQUENCE: {
      const sequenceNode = await createSequenceAndChildrenNodes(event)
      const sequenceNodeInput = sequenceNode.inputs.get(inputSocketName)
      App.editor.connect(output, sequenceNodeInput)      
      break
    }
    case CONST_COMPONENT.POSTBACK: {
      const referenceNode = App.editor.nodes.find(item => item.name === CONST_COMPONENT.POSTBACK)
      if (referenceNode) {
        const referenceNodeInput = referenceNode.inputs.get(inputSocketName)
        App.editor.connect(output, referenceNodeInput)
      }
      break
    }
    default: 
      await createSingleNode(node, event)
  }

  App.editor.removeNode(node)
}

// eslint-disable-next-line
export const createCarouselAndChildrenNodes = async (event = null, ui = null) => {
  const carouselComponent = App.components.get(CONST_COMPONENT.CAROUSEL)
  const carouselComponentInstance = new carouselComponent(App.config)
  const carouselNode = await carouselComponentInstance.createNode()

  if (event) {
    App.editor.view.area.pointermove(event)
  }
  const { x, y } = App.editor.view.area.mouse
  carouselNode.position = [x, y]

  App.editor.addNode(carouselNode)

  const buttonComponent = App.components.get(CONST_COMPONENT.BUTTON)
  const carouselSingleComponent = App.components.get(CONST_COMPONENT.CAROUSEL_ITEM)
  
  const carouselSingles = [
    new carouselSingleComponent(App.config),
    new carouselSingleComponent(App.config),
    new carouselSingleComponent(App.config),
  ]
  
  carouselSingles.map(async (carouselSingle, index) => {
    const carouselSingleNode = await carouselSingle.createNode()
    const buttonInstance = new buttonComponent(App.config)
    const buttonNode = await buttonInstance.createNode()
    
    const carouselSingleY = fixYPositionOfChildComponents(index, 90, carouselSingles.length)
    carouselSingleNode.position = [x + 250, carouselSingleY]

    const buttonY = fixYPositionOfChildComponents(index, 130, carouselSingles.length)
    buttonNode.position = [x + 480, buttonY]
    
    App.editor.addNode(carouselSingleNode)
    App.editor.addNode(buttonNode)

    App.editor.connect(
      carouselNode.outputs.get(CONST_SOCKET.CAROUSEL_OUTPUT_ITEMS), 
      carouselSingleNode.inputs.get(CONST_SOCKET.CAROUSEL_SINGLE_INPUT)
    )
    
    App.editor.connect(
      carouselSingleNode.outputs.get(CONST_SOCKET.CAROUSEL_SINGLE_OUTPUT),
      buttonNode.inputs.get(CONST_SOCKET.BUTTON_INPUT)
    )
  })

  return carouselNode
}

// eslint-disable-next-line
export const createGenericTemplateAndChildrenNodes = async (event = null, ui = null) => {
  const genericTemplateComponent = App.components.get(CONST_COMPONENT.GENERIC_TEMPLATE)
  const genericTemplateComponentInstance = new genericTemplateComponent(App.config)
  const genericTemplateNode = await genericTemplateComponentInstance.createNode()
  
  if (event) {
    App.editor.view.area.pointermove(event)
  }
  const { x, y } = App.editor.view.area.mouse
  genericTemplateNode.position = [x, y]

  App.editor.addNode(genericTemplateNode)
  
  const buttonNode = await createButtonNode()
  buttonNode.position = [x + 250, y]

  App.editor.addNode(buttonNode)

  App.editor.connect(
    genericTemplateNode.outputs.get(CONST_SOCKET.GENERIC_TEMPLATE_OUTPUT_BUTTON),
    buttonNode.inputs.get(CONST_SOCKET.BUTTON_INPUT)
  )

  return genericTemplateNode
}

// eslint-disable-next-line
export const createSequenceAndChildrenNodes = async (event = null, ui = null) => {
  const sequenceComponent = App.components.get(CONST_COMPONENT.SEQUENCE)
  const sequenceComponentInstance = new sequenceComponent(App.config)
  const sequenceNode = await sequenceComponentInstance.createNode()
  
  if (event) {
    App.editor.view.area.pointermove(event)
  }
  const { x, y } = App.editor.view.area.mouse
  sequenceNode.position = [x, y]

  App.editor.addNode(sequenceNode)

  const items = [1, 2, 3]
  
  // eslint-disable-next-line
  items.map(async (item, index) => { 
    const sequenceSingleNodePositionY = fixYPositionOfChildComponents(index, 100, items.length)
    const squenceSingleNodePosition = [x + 250, sequenceSingleNodePositionY]
    const sequenceSingleNode = await addNewSequenceSingleToEditor(squenceSingleNodePosition)

    const childNewPostbackNodePositionY = fixYPositionOfChildComponents(index, 122, items.length)
    const childNewPostbackNodePosition = [x + 500, childNewPostbackNodePositionY]
    const childNewPostbackNode = await addNewPostbackNodeToEditor(childNewPostbackNodePosition)

    App.editor.connect(
      sequenceNode.outputs.get(CONST_SOCKET.SEQUENCE_OUTPUT),
      sequenceSingleNode.inputs.get(CONST_SOCKET.SEQUENCE_SINGLE_INPUT)
    )

    App.editor.connect(
      sequenceSingleNode.outputs.get(CONST_SOCKET.SEQUENCE_SINGLE_OUTPUT),
      childNewPostbackNode.inputs.get(CONST_SOCKET.NEW_POSTBACK_INPUT)
    )
  })

  return sequenceNode
}

const createSingleNode = async (node, event) => {
  const inputSocketName = event.target.dataset.inputSocketName
  const componentName = event.target.dataset.componentName

  const targetNode = await createNodeByComponentName(componentName)
  const { x, y } = App.editor.view.area.mouse
  targetNode.position = [x, y]

  const output = node.output.node.outputs.get(node.output.key)
  const input = targetNode.inputs.get(inputSocketName)

  App.editor.addNode(targetNode)
  App.editor.connect(output, input)
}

export const fixYPositionOfChildComponents = (index, componentHeight, totalComponents) => {
  let halfOfTotal = componentHeight * totalComponents / 2
  return (componentHeight * index) - (halfOfTotal - componentHeight / 2)
}

export const isFileTypeVerified = (file, allowedTypes) => {
  if ((file instanceof File) && Array.isArray(allowedTypes)) {
    if (allowedTypes.indexOf(file.type) > -1) {
      return true
    }
  }

  return false
}

export const addClassToAll = (className, querySelector) => {
  const items = document.querySelectorAll(querySelector)

  Array.from(items).forEach((item) => {
    if (! item.classList.contains(className)) {
      item.classList.add(className)
    }
  })
}

export const removeAllClasses = (className, querySelector) => {
  const items = document.querySelectorAll(querySelector)
  
  Array.from(items).forEach((item) => {
    if (item.classList.contains(className)) {
      item.classList.remove(className)
    }
  })
}

export const showInfo = (message) => {
  Swal.fire({
    title: lang.utils_title_info,
    text: message,
    icon: 'info',
    confirmButtonText: lang.utils_button_ok,
  })
} 

export const showWarning = (message) => {
  Swal.fire({
    title: lang.utils_title_warning,
    text: message,
    icon: 'warning',
    confirmButtonText: lang.utils_button_ok,
  })
}

export const showError = (message) => {
  Swal.fire({
    title: lang.utils_title_error,
    text: message,
    icon: 'error',
    confirmButtonText: lang.utils_button_ok,
  })
} 

export const showSuccess = (message) => {
  Swal.fire({
    title: lang.utils_title_success,
    text: message,
    icon: 'success',
    confirmButtonText: lang.utils_button_ok,
    allowOutsideClick: false,
  })
  .then(result => {
    if (result.isConfirmed && (true === result.isConfirmed)) {
      var go_back_link = window.xitFlowBuilderData.go_back_link
      window.location.replace(go_back_link)
    }
  })
}

export const showAjaxError = (xhr) => {
  Swal.fire({
    title: lang.utils_title_warning,
    html: xhr.responseText,
    icon: 'warning',
    confirmButtonText: lang.utils_button_ok,
  })
}

export const templateComponentMethods = {
  hasData(node) {
    return node.data && (Object.values(node.data).length > 0) 
      ? 'node--has-data'
      : null
  },

  camelCase(name) {
    return camelCase(name)
  },

  startCase(name) {
    return startCase(name)
  },

  isSelected(node) {
    return App.editor.selected.contains(node) 
      ? 'node--selected' 
      : null
  },

  hasConnection(inputOrOutput) {
    return inputOrOutput.connections.length > 0
  },

  handleClick(node) {
    App.handleNodeData(node, App.editor)
  },


  async displayStat (node) {
    return await sleep(250).then(() => {
      const message_sent_stat_addon = window.xitFlowBuilderData.message_sent_stat_addon

      if (! message_sent_stat_addon) {
        return;
      }

      var message_sent_stat = window.xitFlowBuilderData.message_sent_stat

      var uniqueId = ''
      var is_message_sent = false
      // const targetNode = getNextNewPostback(node)

      if(node.name === CONST_COMPONENT.BUTTON)
      {
        uniqueId = node.data.postbackId
      }
      else if(node.name === CONST_COMPONENT.QUICK_REPLY)
      {
        uniqueId = node.data.uniqueId;
        is_message_sent = false
      }
      else
      {
        uniqueId = node.data.uniqueId;
        is_message_sent = true
      }

      var total_sent_click = Object.keys(message_sent_stat).indexOf(uniqueId) > -1 ? message_sent_stat[uniqueId].sent_click : 0
      var total_error = Object.keys(message_sent_stat).indexOf(uniqueId) > -1 ? message_sent_stat[uniqueId].total_error : 0
      var subscribers = Object.keys(message_sent_stat).indexOf(uniqueId) > -1 ? message_sent_stat[uniqueId].subscribers : 0
      var delivered = Object.keys(message_sent_stat).indexOf(uniqueId) > -1 ? message_sent_stat[uniqueId].delivered : 0

      let html = ''

      if (is_message_sent) {
        html += '<ul class="list-group list-group-horizontal list-group-horizontal-custom text-center">'
        html += '<li class="list-group-item"><span><i class="far fa-paper-plane text-info"></i> ' +lang.message_sent_lang+ '</span> <p>' +total_sent_click+ '</p></li>'
        html += '<li class="list-group-item"><span><i class="far fa-check-circle text-success"></i> '+lang.message_sent_stat_delivered+'</span> <p>'+delivered+'</p></li>'
        html += '<li class="list-group-item"><span><i class="far fa-user-circle text-primary"></i> '+lang.message_sent_stat_subscribers+'</span> <p>'+subscribers+'</p></li>'
        html += '<li class="list-group-item"><span><i class="fas fa-bug text-danger"></i> ' +lang.message_sent_stat_error_lang+ '</span> <p>' +total_error+ '</p></li>'
        html += '</ul>'
      }
      else {
        html += '<ul class="list-group list-group-horizontal list-group-horizontal-custom text-center">'
        html += '<li class="list-group-item"><span><i class="far fa-hand-pointer text-info"></i> ' +lang.postback_click_lang+ '</span> <p>' +total_sent_click+ '</p></li>'
        html += '<li class="list-group-item"><span><i class="far fa-user-circle text-primary"></i> '+lang.message_sent_stat_subscribers+'</span> <p>'+subscribers+'</p></li>'
        html += '<li class="list-group-item"><span><i class="fas fa-bug text-danger"></i> ' +lang.message_sent_stat_error_lang+ '</span> <p>' +total_error+ '</p></li>'
        html += '</ul>'
      }

      return html
    })
  }
}


export const hasInputConnectionWith = (node, nodeInputSocketName, OtherNodeOutputSocketName) => {
  const input = node.inputs.get(nodeInputSocketName)

  if (input instanceof Rete.Input) {
    const connections = input.connections
    if (Array.isArray(connections)) {
      for (const connection of connections) {
        if (connection.output.key === OtherNodeOutputSocketName) {
          return true
        }
      }
    }
  }

  return false
}

// https://stackoverflow.com/a/10311375
export const alertBeforeClosingBrowser = () => {
  window.onbeforeunload = function (e) {

    if(true === window.hasXitFlowBuilderData) {
      return
    }

    e = e || window.event

    // For IE and Firefox prior to version 4
    if (e) {
      e.returnValue = 'Sure?'
    }

    // For Safari
    return 'Sure?'
  }
}

export const showPerformanceNoticeForFirefox = (afterSeconds) => {
  setTimeout(async () => {      
    if (! document.cookie.split('; ').find(row => row.startsWith('xitFlowBuilderfirfoxPerformanceNotice'))) {
      const browser = getBrowser()
      const message = `You're using ${browser.name}. For better performace, we recommend use Chrome, Opera or Safari.`
      await Swal.fire({
        title: 'Info!',
        text: message,
        icon: 'info',
        confirmButtonText: 'Dont show again',
        showCancelButton: true,
        cancelButtonText: 'Cancel',
      })
      .then((result) => {
        if (result.isConfirmed) {
          document.cookie = "xitFlowBuilderfirfoxPerformanceNotice=true; SameSite=Strict; expires=Fri, 31 Dec 9999 23:59:59 GMT"
        }
      })
    }
  }, afterSeconds)
}

// https://stackoverflow.com/a/16938481
export const getBrowser = () => {
  var ua = navigator.userAgent,tem,M=ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || []; 
  if(/trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(ua) || []
    return {
      name:'IE', 
      version:(tem[1] || '')
    }
  }

  if(M[1] === 'Chrome') {
    tem = ua.match(/\bOPR|Edge\/(\d+)/)
    if(tem != null) {
      return {
        name:'Opera', 
        version: tem[1]
      }
    }
  }

  M = M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?']
  if((tem=ua.match(/version\/(\d+)/i)) != null) {
    M.splice(1, 1, tem[1])
  }

  return {
    name: M[0],
    version: M[1]
  }
}

export const sweetAlertCommonParams = (node, width = "19rem") => {
  const nodeName = camelCase(node.name)

  return {
    width: width,
    position: 'top-end',
    focusConfirm: false,
    buttonsStyling: false,
    showCancelButton: true,
    confirmButtonText: lang.swal_button_ok,
    cancelButtonText: lang.swal_button_cancel,
    customClass: {
      container: 'node-id-' + node.id + ' ' + nodeName,
      popup: 'p-2',
      header: 'p-0 mt-4',
      content: 'p-0',
      actions: 'd-flex justify-content-between p-0 m-0 pt-4 pb-4',
      footer: 'p-0',
      confirmButton: 'btn btn-outline-primary',
      denyButton: 'btn btn-outline-danger',
      cancelButton: 'btn btn-outline-secondary',
    },
    showClass: {
      popup: false,
    },
  }
}

export const removeConnectionsHavingUnmatch = (node, match, socketName) => {
  const nodeDataValues = Object.values(node.data)
  if (nodeDataValues.length > 0) {
    let breakStatus = false
    const connections = getNodeOutputConnectionsBySocketName(socketName, node)

    if (match.length > 0 && connections.length > 0) {
      for(const item of match) {
        if (! (nodeDataValues.indexOf(item) > -1)) {
          removeNodeConnections(connections)
        } else {
          breakStatus = true
        }

        if (breakStatus) {
          return
        }
      }
    }
  }
}

export const getNodeOutputConnectionsBySocketName = (socketName, node) => {
  const outputs = node.outputs.get(socketName)
  return (outputs && outputs.connections) ? outputs.connections : []
}

export const getNodeInputConnectionsBySocketName = (socketName, node) => {
  const inputs = node.inputs.get(socketName)
  return (inputs && inputs.connections) ? inputs.connections : []
}

const removeNodeConnections = (connections) => {
  connections.map(singleConnection => {
    App.editor.removeConnection(singleConnection)
  })
}

export const updateNodeConnections = (node, timeout = 100) => {
  setTimeout(() => {
    App.editor.view.updateConnections({ node })
    // node.update()
  }, timeout)
}

export const getSelectOptionsFromArrayOfObjects = (optionsArray, defaultValue = '') => {
  let html = ''
  for (const option of optionsArray) {
    if ('string' === typeof option) {
      if (defaultValue === option) {
        html += '<option value="' + option + '" selected>' + option + '</option>'
      } else {
        html += '<option value="' + option + '">' + option + '</option>'
      }
    } else if ('object' === typeof option) {
      if (defaultValue === option.key) {
        html += '<option value="' + option.key + '" selected>' + option.value + '</option>'
      } else {
        html += '<option value="' + option.key + '">' + option.value + '</option>'
      }
    }
  }

  return html
}

export const getSelectOptionsFromObject = (optionsObject, defaultValue = '') => {
  let html = ''
  const options = Object.keys(optionsObject);
  for (const option of options) {
    if (defaultValue === option) {
      html += '<option value="' + option + '" selected>' + optionsObject[option] + '</option>'
    } else {
      html += '<option value="' + option + '">' + optionsObject[option] + '</option>'
    }
  }

  return html
}

export function isPlainObject(obj) {
  return obj ? obj.constructor === {}.constructor : false
}

/**
 * Get file mime type from URL
 * 
 * @param {string} url
 * @param {function} callback 
 */
export function getMimeTypeFromUrl(url) {
  let mimeType = null
  const xhr = new XMLHttpRequest()

  xhr.open('HEAD', url)
  xhr.onreadystatechange = function () {
    if (this.readyState == this.DONE) {
      mimeType = this.getResponseHeader("Content-Type")
    }
  }

  xhr.send()

  return mimeType
}

const getUniqueId = () => {
  let count = 5
  return () => count++
}

export const uniqueId = getUniqueId()

export function hasDuplicates(array) {
  return (new Set(array)).size !== array.length;
}

export const createSelect2DynamicOption = (element) => {
  var page_table_id = window.xitFlowBuilderData.page_table_id
  var base_url = window.xitFlowBuilderData.base_url
  var instagram_bot_addon = window.xitFlowBuilderData.instagram_addon
  const social_media = instagram_bot_addon ? 'ig' : 'fb'

  $(element).select2({
    tags: true,
    width: '100%',
    dropdownParent: $('#swal2-content'),
  }).on('select2:select', function(e) {
    const data = e.params.data
    const tagsList = $(this).select2('data')

    if (tagsList.find(val => (val.selected === true && val.text === data.text)) !== undefined) {
      tagsList.push({ id: data.id, text: data.text })
      $(element).select2('data', tagsList)
    } else { 
      $.ajax({
        type:'POST',
        dataType:'JSON',
        url: base_url + "home/common_create_label_and_assign",
        data:{ page_id: page_table_id, label_name: data.text, social_media },
        success: function(response) {
          if(response.error) {
            Swal.showValidationMessage('Could not create label.')
          } else {
            const isDummyOptionAdded = $(element).find("option[value='" + data.text + "']")
            if (isDummyOptionAdded) {
              isDummyOptionAdded.remove();
            }
            
            const newOption = new Option(response.text, response.id, true, true)
            $(element).append(newOption).trigger('change');
          }
        }
      })
    } 
  })
}

export const makeAjaxCall = (callback, data) => {
  const parameters = {
    url: data.url,
    dataType: 'JSON',
    success: callback,
  }

  if (data.method && ('get' === data.method.toLowerCase())) {
    parameters.type = 'GET'
  } else {
    parameters.type = 'POST'
    parameters.data = data.data
  }

  $.ajax(parameters)
}

export const selectedOptionsTextArray = (selectedOptions) => {
  const optionsTextArray = []
  if (Object.keys(selectedOptions).length > 0) {
    for (const text of selectedOptions) {
      optionsTextArray.push(text.label)
    }
  }

  return optionsTextArray
}

export const prepareDropdownLists = (response) => {
  let html = '';

  if (Array.isArray(response)) {
    response.forEach((val, idx) => { // eslint-disable-line
      html += '<span class="dropdown-item">' + val.value + '</span>'
    })
  }

  return html;
}

export const setDefaultComponentBasedOnUrlParams = (params) => {
  const delegator = parseDelegatorClassFromUrlParams(params)
  if (! (delegator instanceof CreateDefaultComponent)) {
    throw new Error('Invalid "type" param provided.')
  }

  delegator.setupDefaultComponent()
}

const parseDelegatorClassFromUrlParams = (params) => {
  if (! params.type) {
    throw new Error('"Type" was not provided in URL params.')
  }

  const config = App.config.defaultComponentMappingTypeToClass
  const delegatorClass = config[params.type] || null

  return delegatorClass ? new delegatorClass(params) : null
}

export const sleep = (seconds) => {
  return new Promise(resolve => setTimeout(resolve, seconds))
}